<template>
  <div
    ref="content"
    class="shopping-cart"
    :style="{ paddingTop: union ? '30px' : '' }"
  >
    <div class="title_line">
      <h2>{{TLang('我的购物车','list')}}</h2>
      <div class="address_line">
        <AddressRow
          :onAddressChange="this.onAddressChange"
          width="490"
          height="325"
          :showFeight="false"
        />
      </div>
    </div>
    <div
      v-if="!isEmpty"
      class="shopping-list-wrap"
    >
      <el-row
        v-if="userCartList.length"
        justify="between"
        class="list-header"
      >
        <el-col
          :span="3"
          class="all-checked"
        >
          <div
            v-if="allChoose"
            class="checked"
            @click="onClickAllBtn"
          >
            <i class="el-icon-check"></i>
          </div>
          <div
            v-else
            @click="onClickAllBtn"
          >
            <i class="not-check"></i>
          </div>
          <span>{{TLang('全选','list')}}</span>
        </el-col>
        <el-col
          :span="9"
          align="left"
        >
          {{TLang('商品信息','orderConfirm')}}
        </el-col>
        <el-col
          :span="3"
          align="center"
        >
          {{TLang('单价','orderConfirm')}}({{ union_name || TLang('福豆', 'card') }})
        </el-col>
        <el-col
          :span="3"
          align="center"
        >
          {{TLang('数量','orderConfirm')}}
        </el-col>
        <el-col
          :span="3"
          align="center"
        >
          {{TLang('金额','orderConfirm')}}({{ union_name || TLang('福豆', 'card') }})
        </el-col>
        <el-col
          :span="3"
          align="center"
        >
          {{TLang('操作','list')}}
        </el-col>
      </el-row>
      <div class="user-list">
        <ul>
          <li
            v-for="(merItem, index) in userCartList"
            :key="index"
          >
            <div>
              <MerchantRow
                :userCartItem="merItem"
                :onSignChange="onSignChange"
                :handleClickMerItem="onSignedMerItem"
                :handleCheckoutSpec="onCheckSpec"
                :handleUpdateGoodsNum="onUpdateGoodsNum"
                :handleDelGoods="onDelGoods"
                :isBFD="isBFD"
              />
            </div>
          </li>
        </ul>
      </div>
      <div>
        <InvalideGoods
          v-if="invalideGoods.length"
          :invalideGoods="invalideGoods"
          :clearAll="onClear"
          :clearOne="delOneInvalideGood"
        />
      </div>
    </div>
    <div
      v-if="userCartList.length"
      ref="sticky"
      :class="['pay-sticky', showPayBar ? 'sticky-active' : ' ']"
    >
      <div class="sticky-wrap">
        <div class="all-checked flex">
          <div
            v-if="allChoose"
            class="checked"
            @click="onClickAllBtn"
          >
            <i class="el-icon-check"></i>
          </div>
          <div
            v-else
            @click="onClickAllBtn"
          >
            <i class="not-check"></i>
          </div>
          <span :style="{ marginLeft: '12px' }">{{TLang('全选','list')}}</span>
        </div>
        <div
          :style="{
            marginLeft: '24px',
            color: (signedIds.length && '#3D96E2') || '#666',
          }"
          @click="onClickDel"
        >
          {{TLang('删除选中商品','list')}}
        </div>
        <div
          v-if="invalideGoods.length"
          :style="{ marginLeft: '24px' }"
          @click="invalideDialogVisible = true"
        >
          {{TLang('清空失效商品','list')}}
        </div>
        <div :style="{ marginLeft: 'auto' }">
          <div :style="{display:'flex', height:'25px'}">
            {{TLang('已选商品','list')}}<li>{{ totalCount }}</li>{{TLang('件','list')}}
            <div :style="{marginLeft:'5px'}">{{ TLang("合计", "orderConfirm") }}</div>
            <div>
              <img
                :src="union_icon || require('./../../assets/images/fudou.png')"
                alt
              />
              <span class="pay-text">{{
                (shouldPay * union_scale).toFixed(2)
              }}</span>
            </div>
          </div>
          <div :style="{fontSize:'12px', color:'#999999'}">
            {{TLang('不含运费','list')}}
            <span v-if="serviceFee > 0">，{{ TLang('含平台服务费','my') }}{{(serviceFee * union_scale).toFixed(2)}}</span>
          </div>
        </div>    
        <div
          class="payfor-btn"
          @click="onClickConfirm"
        >
          {{ TLang('去结算','my') }}
        </div>
      </div>
    </div>
    <Dialog
      title=" "
      :visible.sync="delDialogVisible"
      width="420px"
      custom-class="shopping-dialog"
      center
      top="45vh"
      @open="delDialogVisible = true"
    >
      <div class="imgbox">
        <img :src="require('../../assets/images/delete.png')" />
      </div>
      <div class="title" v-if="!checkGoodsPrize()">
        {{ TLang('您要删除选中的商品吗','list') }}
      </div>
      <div v-if="checkGoodsPrize()">
        <div class="prizeTitle">{{ TLang('已选删除即视为放弃该奖品','list') }}</div>
        <div class="prizeTitle">{{ TLang('确认删除选中的商品','list') }}</div>
      </div>
      <div class="btns">
        <button
          class="close-btn primary"
          @click="deleteSign"
        >
          {{ TLang('删除','address') }}
        </button>
        <button
          class="buy-btn"
          @click="delDialogVisible = false"
        >
          {{ TLang('不删除','list') }}
        </button>
      </div>
    </Dialog>
    <Dialog
      title=" "
      :visible.sync="invalideDialogVisible"
      width="420px"
      custom-class="shopping-dialog"
      center
      @open="invalideDialogVisible = true"
    >
      <div class="imgbox">
        <img :src="require('../../assets/images/delete.png')" />
      </div>
      <div class="title">
        {{ TLang('您要清空失效商品吗','list') }}
      </div>
      <div class="btns">
        <button
          class="close-btn primary"
          @click="onClear"
        >
          {{ TLang('清空','list') }}
        </button>
        <button
          class="buy-btn"
          @click="invalideDialogVisible = false"
        >
          {{ TLang('不清空','list') }}
        </button>
      </div>
    </Dialog>
    <Empty v-if="isEmpty" />
    <FixedButton hideCart />
    <Confirm
      :showConfirm="isShowConfirm"
      :products="errorProducts"
      @callback="confirmCallBack"
    />
    <NumChangeDialog
      :showNumDialog="showNumDialog"
      :goodsList="goodsNumScopeDTOList"
      @callback="closeNumChangeDialog"
    />
  </div>
</template>

<script>
import AddressRow from './../product/detail/AddressRow';
import MerchantRow from './MerchantRow';
import Confirm from './confirm';
import InvalideGoods from './invalideGoods';
import Empty from './Empty';
import Loading from '@components/SimpleLoading';
import NumChangeDialog from '@components/NumChangeDialog';
import {
  fetchCartList,
  signCartGoods,
  updateGoodsFlag,
  updateCartItemNum,
  deleteCartGoods,
  buyGoodsInfosCheck,
} from '@fetch/shopping';
import { fetchGoodsTags } from '@fetch';
import Toast from '@components/simpleToast';
import { Dialog } from 'element-ui';
import Cookies from 'js-cookie';
import FixedButton from '@components/FixedButton';
import { unionFlag, countTime, gioClickHandle } from '@utils';
export default {
  components: {
    AddressRow,
    MerchantRow,
    InvalideGoods,
    Empty,
    Dialog,
    FixedButton,
    Confirm,
    NumChangeDialog,
  },
  data() {
    return {
      isShowConfirm: false,
      errorProducts: [],
      addressInfo: Cookies.get('address') && JSON.parse(Cookies.get('address')),
      userCartList: [],
      serviceFee: 0,
      invalideGoods: [],
      allChoose: false,
      signedIds: [],
      not_signedIds: [],
      invalideIds: [],
      shouldPay: 0,
      isEmpty: false,
      showPayBar: true,
      delDialogVisible: false,
      invalideDialogVisible: false,
      buyGoodsList: [],
      goodsNumScopeDTOList: [],
      showNumDialog: false,
      union: unionFlag(),
      activityArr: [],
      needUpdate: false,
      needInfo: {},
      pointNewConfirm: false, // 是否指向新的订单确认页 是 指向
      isBFD: false, // 是否指向新的订单确认页 是 指向
    };
  },
  computed: {
    totalCount() {
      const count = this.buyGoodsList.reduce((prev, next) => {
        return prev + next.num;
      }, 0);
      return count;
    },
    // 请求tags接口的参数
    goodsList() {
      let list = this.userCartList;
      let paramsList = [];
      list.forEach((item) => {
        if (item && item.merchantGoods.length > 0) {
          item.merchantGoods.forEach((goods) => {
            if (goods && goods.goodsId && goods.categoryId) {
              paramsList.push({
                goodsId: goods.goodsId,
                categoryId: goods.categoryId,
              });
            }
          });
        }
      });
      return paramsList;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, false);
    this.renderPage();
    // 移除提交订单页指定日期配送上次选中的日期缓存
    window.sessionStorage.removeItem('pcDeliverWay3');
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll, false);
  },
  methods: {
    renderPage() {
      this.signedIds = [];
      this.not_signedIds = [];
      this.invalideIds = [];
      this.buyGoodsList = [];
      this.goodsNumScopeDTOList = [];
      this.activityArr = [];
      Loading.show();
      fetchCartList({ ...this.addressInfo, appId: '100037' }).then((body) => {
        Loading.hide();
        this.invalideGoods = body && body.invalidGoods ? body.invalidGoods : [] ;
        this.buyGoodsList = [];
        this.goodsNumScopeDTOList = body.goodsNumScopeDTOList ? body.goodsNumScopeDTOList : [] ;
        this.pointNewConfirm = body.pointNewConfirm? body.pointNewConfirm : false;
        this.isBFD = body.platform===2;
        console.log('test',this.isBFD)
        if (this.goodsNumScopeDTOList.length > 0) {
          this.showNumDialog = true;
        }
        body && body.userCartList.map((mer, a) => {
          this.activityArr.push([]);
          if (mer.merchantGoods && mer.merchantGoods.length) {
            mer.merchantGoods.map((goods, index) => {
              // 促销倒计时
              if (
                goods &&
                goods.mktSkuDetail &&
                goods.mktSkuDetail.length > 0
              ) {
                goods.showMarketTime = countTime(goods.mktSkuDetail[0].endTime);
              }
              goods.signed
                ? this.signedIds.push(goods.id)
                : this.not_signedIds.push(goods.id);
              if (goods.signed === 1 && !this.checkSame(goods, this.buyGoodsList)) {
                let curItem = {
                  categoryId: goods.categoryId,
                  goodsId: goods.goodsId,
                  num: goods.num,
                  bookId: goods.bookId,
                };
                if (goods.cartGoodsType) {
                  curItem.cartGoodsType = goods.cartGoodsType;
                }
                if (goods.mktRelaId) {
                  curItem.mktRelaId = goods.mktRelaId;
                }
                this.buyGoodsList.push(curItem);
              }
              // 遍历活动信息，存储在activityArr中，用于调整userCartList的商品顺序:同一商家→相同活动→勾选的放上面
              if (goods.fullReductionInfo) {
                if (this.activityArr[a].length <= 0) {
                  this.activityArr[a].push({
                    activityId: goods.fullReductionInfo.activityId, // 当前活动ID
                    num: 1, // 同一活动中商品的数量
                    startIndex: index, // 第一个活动商品位置
                    showIndex: goods.signed === 1 ? index : -1, // 第一个被勾选的活动商品位置
                    signIndex: goods.signed === 1 ? [index] : [], // 所有被勾选的商品位置
                    unSignIndex: goods.signed === 1 ? [] : [index], // 所有未被勾选的商品位置
                  });
                } else {
                  let hasActivityInfo = false;
                  for (var i = 0; i < this.activityArr[a].length; i++) {
                    let curId = this.activityArr[a][i].activityId;
                    if (goods.fullReductionInfo.activityId == curId) {
                      this.activityArr[a][i].num =
                        this.activityArr[a][i].num + 1;
                      if (
                        goods.signed === 1 &&
                        this.activityArr[a][i].showIndex < 0
                      ) {
                        this.activityArr[a][i].showIndex = index;
                        this.activityArr[a][i].signIndex.push(index);
                      } else if (goods.signed != 1) {
                        this.activityArr[a][i].unSignIndex.push(index);
                      }
                      hasActivityInfo = true;
                    }
                  }
                  if (!hasActivityInfo) {
                    this.activityArr[a].push({
                      activityId: goods.fullReductionInfo.activityId,
                      num: 1,
                      startIndex: index,
                      showIndex: goods.signed === 1 ? index : -1,
                      signIndex: goods.signed === 1 ? [index] : [],
                      unSignIndex: goods.signed === 1 ? [] : [index],
                    });
                  }
                }
              }
            });
          }
        });
        // 调整顺序
        if (this.activityArr.length > 0) {
          for (var m = 0; m < this.activityArr.length; m++) {
            if (this.activityArr[m].length > 0) {
              for (var n = 0; n < this.activityArr[m].length; n++) {
                if (
                  this.activityArr[m][n].startIndex ==
                    this.activityArr[m][n].showIndex ||
                  this.activityArr[m][n].showIndex < 0 ||
                  this.activityArr[m][n].num <= 1
                ) {
                  // 不换顺序
                } else {
                  // 换顺序，前提：后端将同一商家同一活动商品放在一起
                  if (this.activityArr[m][n].num == 2) {
                    let arr = body.userCartList[m].merchantGoods;
                    let index1 = this.activityArr[m][n].startIndex;
                    let index2 = this.activityArr[m][n].showIndex;
                    arr[index1] = arr.splice(index2, 1, arr[index1])[0];
                  } else {
                    let signArr = [];
                    for (
                      var p = 0;
                      p < this.activityArr[m][n].signIndex.length;
                      p++
                    ) {
                      let curIndex = this.activityArr[m][n].signIndex[p];
                      signArr.push(
                        body.userCartList[m].merchantGoods[curIndex],
                      );
                    }
                    let unSignArr = [];
                    for (
                      var q = 0;
                      q < this.activityArr[m][n].unSignIndex.length;
                      q++
                    ) {
                      let curUnIndex = this.activityArr[m][n].unSignIndex[q];
                      unSignArr.push(
                        body.userCartList[m].merchantGoods[curUnIndex],
                      );
                    }
                    let arr = body.userCartList[m].merchantGoods;
                    let startArr = arr.slice(
                      0,
                      this.activityArr[m][n].startIndex,
                    );
                    let endArr = arr.slice(
                      this.activityArr[m][n].startIndex +
                        this.activityArr[m][n].num,
                    );
                    if (startArr.length > 0) {
                      body.userCartList[m].merchantGoods = startArr.concat(
                        signArr,
                        unSignArr,
                        endArr,
                      );
                    } else {
                      body.userCartList[m].merchantGoods = signArr.concat(
                        unSignArr,
                        endArr,
                      );
                    }
                  }
                }
              }
            }
          }
        }
        // 遍历头部满减信息的显示
        body && body.userCartList.map((mer) => {
          if (mer.merchantGoods && mer.merchantGoods.length) {
            let activityNum = 0;
            mer.merchantGoods.map((goods) => {
              if (goods.fullReductionInfo) {
                let activityId = goods.fullReductionInfo.activityId;
                if (activityId != activityNum) {
                  goods.showActivity = true;
                  activityNum = activityId;
                } else {
                  goods.showActivity = false;
                }
              } else {
                goods.showActivity = false;
              }
            });
          }
        });
        // this.shouldPay = body.checkAmount;
        // 减去了优惠
        this.shouldPay = body && body.total;
        if (body && body.invalidGoods && body.invalidGoods.length > 0) {
          body.invalidGoods.map((igoods) => {
            this.invalideIds.push(igoods.id);
          });
        }
        if (!body.userCartList.length && !body.invalidGoods.length) {
          this.isEmpty = true;
        }
        this.userCartList = this.transformCoreData(body.userCartList);
        this.serviceFee = body.serviceFee;
        this.getGoodsTags();
        // 处理失效商品的业务库存
        this.getGoodsBizStock(this.invalideGoods);
        // this.handleScroll();
      });

      // console.log(this.buyGoodsList);
    },
    // 校验goodsId是否已存在
    checkSame (info, list) {
      let hasFlag = false;
      info.goodsId && list && list.length > 0 && list.forEach((goods) => {
        // 存在多频道同商品goodsId的情况，所以需增加分类categoryId的判断（频道不同，分类不同）
        if (goods && goods.goodsId && info.goodsId == goods.goodsId && info.categoryId == goods.categoryId) {
        // if (goods && goods.goodsId && info.goodsId == goods.goodsId) {
          if (info.cartGoodsType == goods.cartGoodsType) {
            // 活动奖品
            hasFlag = true;
          }
        }
      });
      return hasFlag;
    },
    handleScroll() {
      // this.$refs.sticky.offsetHeight === 72
      if (
        this.$refs.content.getBoundingClientRect().bottom +
          Number(this.showPayBar) * 98 -
          72 <=
        window.screen.availHeight
      ) {
        this.showPayBar = false;
      } else {
        this.showPayBar = true;
      }
    },
    changeGio(df_modulename, df_elementname) {
      try {
        let channel = '';
        const params = {
          df_channle: channel,
          df_modulename: df_modulename,
          df_elementname: df_elementname,
        };
        gioClickHandle('DF_elementClick', params, 'cart');
      } catch (e) {
        console.log('埋点失败:', e);
      }
    },
    onAddressChange(address) {
      if (address) {
        this.addressInfo = address;
        Cookies.set('address', address, { expires: 365 });
        console.log('Cookies.set8', address);
        this.renderPage();
      }
      this.changeGio('收货地址','送至');
    },
    onSignChange(goods) {
      signCartGoods({
        signed: Math.abs(goods.signed - 1),
        signedIdsList: [goods.id],
      }).then(() => {
        this.renderPage();
      });
    },
    // 添加必要参数
    transformCoreData(userCartList) {
      let merchantSigned = 0;
      let cartList = [...userCartList];
      cartList.map((item) => {
        if (item.merchantGoods && item.merchantGoods.length) {
          let signedPlus = 0;
          item.merchantGoods.map((goods) => {
            signedPlus += goods.signed;
          });
          signedPlus >= item.merchantGoods.length
            ? (item.signed = 1)
            : (item.signed = 0);
        }
      });
      cartList.map((mer) => {
        merchantSigned += mer.signed;
      });
      this.allChoose = cartList.length === merchantSigned;
      return cartList;
    },
    // 全选（取消全选）仓库下面的所有商品
    onSignedMerItem(merItem) {
      let alreadySigned = false; // 是否是全选状态
      let signedNum = 0;
      let merSignedIds = [];
      let not_merSignedIds = [];
      if (merItem.merchantGoods && merItem.merchantGoods.length) {
        merItem.merchantGoods.map((goods) => {
          signedNum += goods.signed;
          goods.signed
            ? merSignedIds.push(goods.id)
            : not_merSignedIds.push(goods.id);
        });
        alreadySigned = merItem.merchantGoods.length === signedNum;
      }
      signCartGoods({
        signed: Math.abs(Number(alreadySigned) - 1),
        signedIdsList: alreadySigned ? merSignedIds : not_merSignedIds,
      }).then(() => {
        this.renderPage();
      });
    },
    onClickAllBtn() {
      signCartGoods({
        signed: Math.abs(Number(this.allChoose) - 1),
        signedIdsList: this.allChoose ? this.signedIds : this.not_signedIds,
      }).then(() => {
        this.renderPage();
      });
    },
    onCheckSpec(newGoods, oldGoods) {
      const { addressInfo } = this;
      this.changeGio('商品','切换商品规格');
      updateGoodsFlag({
        ...addressInfo,
        categoryId: newGoods.categoryId,
        goodsId: newGoods.goodsId,
        id: oldGoods.id,
        goodsNum: oldGoods.num,
      }).then((body) => {
        if (body === '成功') {
          this.renderPage();
        } else {
          Toast.info(body.msg, 1);
        }
      });
    },
    onUpdateGoodsNum(val, goods) {
      this.changeGio('商品数量','修改商品数量');
      this.needUpdate = false;
      if (!this.showNumDialog) {
        updateCartItemNum({
          ...this.addressInfo,
          id: goods.id,
          goodsNum: val,
        }).then((res) => {
          if (res.code) Toast.info(res.msg.split('：')[2] || this.TLang('修改失败','user'), 1);
          this.renderPage();
        });
      } else {
        this.needUpdate = true;
        this.needInfo = {
          val: val,
          goods: goods,
        }
      }
    },
    onDelGoods(goods) {
      deleteCartGoods({ deleteIdsList: [goods.id] }).then(() => {
        this.renderPage();
      });
    },
    deleteSign() {
      deleteCartGoods({ deleteIdsList: this.signedIds }).then(() => {
        this.delDialogVisible = false;
        this.renderPage();
      });
    },
    onClickDel() {
      if (this.signedIds.length) {
        this.changeGio('删除商品','删除');
        this.delDialogVisible = true;
      } else {
        Toast.warn(this.TLang('您还没有选择商品哦','user'), 1);
      }
    },
    onClear() {
      deleteCartGoods({ deleteIdsList: this.invalideIds }).then((body) => {
        this.invalideDialogVisible = false;
        this.renderPage();
      });
    },
    onClickConfirm() {
      const ids = this.buyGoodsList.map(function(t) {
        return { categoryId: t.categoryId, goodsId: t.goodsId };
      });
      const params = { buyGoodsDetailDtoList: ids };
      this.errorProducts = [];
      buyGoodsInfosCheck(params).then((body) => {
        if (
          body &&
          body.buyGoodBackDtoLists &&
          body.buyGoodBackDtoLists.length > 0
        ) {
          this.isShowConfirm = true;
          this.errorProducts = body.buyGoodBackDtoLists;
        } else {
          this.goToOrderPage();
        }
      });
      this.changeGio('结算','去结算');
    },
    goToOrderPage() {
      const ORDER_PATH = `/shop/order/confirm?orderType=1&buyGoodsList=${encodeURIComponent(
        JSON.stringify(this.buyGoodsList),
      )}`;
      const ORDER_NEW_PATH = `/shop/order/confirmNew?orderType=1&buyGoodsList=${encodeURIComponent(
        JSON.stringify(this.buyGoodsList),
      )}`;

      if (this.signedIds.length === 0) {
        Toast.warn(this.TLang('您还没有选择商品哦','user'), 1);
      } else {
        if (this.pointNewConfirm){
          window.df_sdk_common.location.href = ORDER_NEW_PATH;
        } else {
          window.df_sdk_common.location.href = ORDER_PATH;
        }
      }
    },
    confirmCallBack(type) {
      if (type === 'next') {
        this.goToOrderPage();
      } else {
        this.isShowConfirm = false;
        this.errorProducts = [];
      }
    },
    delOneInvalideGood(good) {
      deleteCartGoods({ deleteIdsList: [good.id] }).then((body) => {
        if (body) this.renderPage();
      });
    },
    // 获取爆炸贴信息
    getGoodsTags() {
      if (this.goodsList && this.goodsList.length > 0) {
        fetchGoodsTags({
          goodsList: this.goodsList,
          channel: 2,
          // functionType: 1,
        }).then((res) => {
          if (res && res.length > 0) {
            this.addStickerInfo(res);
          } else {
            this.handleScroll();
          }
        });
      } else {
        this.handleScroll();
      }
    },
    // 获取失效商品业务库存
    getGoodsBizStock() {
      if (this.invalideGoods && this.invalideGoods.length > 0) {
        let goodsList = []
        this.invalideGoods.forEach((goods) => {
          if(goods.goodsId && goods.categoryId){
            goodsList.push({ categoryId: goods.categoryId, goodsId: goods.goodsId })
          }
        })
        goodsList.length > 0 && fetchGoodsTags({ goodsList: goodsList, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
            this.addBizStockInfo(res);
            }
          }
        );
      }
    },
    // 添加爆炸贴信息及标签数据
    addStickerInfo(res) {
      this.userCartList.forEach((item) => {
        item.merchantGoods.forEach((goods) => {
          const goodTag = res.find((tag) => {
            return (
              tag.categoryId == goods.categoryId && tag.goodsId == goods.goodsId
            );
          });
          let tags = goodTag && goodTag.tags ? goodTag.tags : [];
          let stickerImgList = tags.filter((item) => item.type === 2);
          //爆炸贴数据
          this.$set(goods, 'stickerImgList', stickerImgList);
          //标签数据
          this.$set(goods, 'tags', tags);
          this.handleScroll();
        });
      });
    },
    // 添加业务库存信息
    addBizStockInfo(res) {
      this.invalideGoods.forEach((goods) => {
        const goodTag = res.find((tag) => {
          return (
            tag.categoryId == goods.categoryId && tag.goodsId == goods.goodsId
          );
        });
        const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
        // 业务库存数据
        this.$set(goods, "bizStock", bizStock);
      })
    },
    // 关闭数量变化弹框
    closeNumChangeDialog() {
      this.showNumDialog = false;
      if (this.needUpdate) {
        this.onUpdateGoodsNum(this.needInfo.val, this.needInfo.goods)
      }
    },
    // 判断所选商品中是否包含奖品
    checkGoodsPrize() {
      let flag = false;
      this.userCartList && this.userCartList.length > 0 && this.userCartList.forEach((i, a) => {
        i.merchantGoods && i.merchantGoods.length > 0 && i.merchantGoods.forEach((j, b) => {
          if (j.signed == 1 && j.cartGoodsType && j.cartGoodsType == 2) {
            flag = true;
            return flag;
          }
        });
      });
      return flag;
    },
  },
};
</script>

<style lang="less">
.shopping-cart {
  padding-bottom: 80px;
  max-width: 1200px;
  margin: 0 auto;
  .not-check {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: 1px solid rgba(204, 204, 204, 1);
    margin-left: 15px;
    line-height: 14px;
    text-align: center;
    vertical-align: sub;
    background: #fff;
  }
  .checked {
    width: 16px;
    height: 16px;
    background: rgba(61, 150, 226, 1);
    color: #fff;
    line-height: 14px;
    text-align: center;
    border-radius: 2px;
    margin-left: 15px;
    display: inline-block;
    vertical-align: sub;
  }
  .title_line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      font-size: 20px;
      font-weight: bold;
      color: rgba(17, 17, 17, 1);
    }
    .address_line {
      .chooseAddress {
        right: -1px;
        left: auto;
      }
      .address-pick .product-address .stock {
        margin-left: 0;
      }
    }
  }
  .shopping-list-wrap {
    position: relative;
    .list-header {
      line-height: 40px;
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
      background: rgba(247, 247, 247, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      margin-top: 16px;
      .all-checked {
        display: flex;
        align-items: center;
        // background: #fff;
        span {
          margin-left: 12px;
        }
      }
    }
  }
  .pay-sticky {
    margin-top: 24px;
    .sticky-wrap {
      display: flex;
      height: 72px;
      border: 1px solid rgba(229, 229, 229, 1);
      margin-top: 24px;
      line-height: 72px;
      color: #666666;
      width: 1200px;
      margin: 0 auto;
      align-items: center;
    }
    &:hover div {
      cursor: pointer;
    }
    img {
      width: 16px;
      height: 16px;
      padding-bottom: 2px;
    }
    .payfor-btn {
      width: 180px;
      height: 72px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      font-size: 20px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
    .pay-text {
      font-size: 20px;
      font-weight: bold;
      color: rgba(244, 69, 69, 1);
      margin-right: 32px;
    }
    .pay-pre {
      margin-right: 16px;
      i {
        font-weight: 500;
        font-size: 18px;
        line-height: 74px;
        color: #333;
      }
    }
  }
  .sticky-active {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.1);
    .sticky-wrap {
      border: none;
      // margin-top: 24px;
    }
  }
  .shopping-dialog {
    transform: translateY(-50%);
    text-align: center;
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        font-size: 24px;
        top: 15px;
      }
    }
    .el-dialog__body {
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: center;
      padding: 25px 0 30px;
      .imgbox {
        text-align: center !important;
      }
      .title {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        text-align: center !important;
        line-height: 24px;
      }
      .prizeTitle {
        font-size: 18px;
        // font-family: MicrosoftYaHei;
        color: #333333;
        line-height: 24px;
      }
      .btns {
        margin-top: 30px;
        text-align: center;
        button {
          width: auto;
          min-width: 88px;
          height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          line-height: 40px;
          &.buy-btn {
            color: #e5e5e5;
            border: 1px solid #e5e5e5;
            background: #fff;
            color: #999;
          }
          &:hover {
            cursor: pointer;
          }
        }
        .close-btn {
          border: 1px solid rgba(229, 229, 229, 1);
          color: #999;
          margin-right: 30px;
          width: auto;
          min-width: 88px;
          border: none;
        }
        .primary {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          border-radius: 4px;
          color: #fff;
        }
      }
    }
    .el-dialog__body {
      text-align: center !important;
    }
  }
  .address-content {
    ul {
      max-height: 190px !important;
    }
  }
}
</style>
